export default "__VITE_ASSET__B4hZJ6h8__"